<section>

    <div class="page page-dashboard">
        <div class="pageheader">
            <h2>User Details</h2>
            <div class="page-bar">


            </div>
        </div>

        <div class="pagecontent">
            <div class="row">
                <div class="col-sm-12">
                    <div class="tile tile-simple">

                        <!-- tile body -->
                        <div class="tile-body">
                            <div role="tabpanel">
                                <div class="tab-content">
                                    <table class="table table-bordered table-striped table-hover">
                                        <tbody>

                                            <tr>
                                                <td>Package</td>
                                                <td> {{ userdata?.package_name }}  </td>
                                            </tr>
                                            <tr>
                                                <td width="20%">Timetable</td>
                                                <td><mat-slide-toggle [checked]="timetable" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.timetable_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Servicing </td>
                                                <td><mat-slide-toggle [checked]="servicing" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.servicing_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Human Resources</td>
                                                <td><mat-slide-toggle [checked]="human_resource" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.humanresources_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Mesurement Tool</td>
                                                <td><mat-slide-toggle [checked]="mesurement_tool" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.meastools_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Problem Solving</td>
                                                <td><mat-slide-toggle [checked]="problem_solving" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.probsolve_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Doc Management</td>
                                                <td><mat-slide-toggle [checked]="doc_management" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.docmang_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Clients</td>
                                                <td><mat-slide-toggle [checked]="clients" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.clients_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Consultancy</td>
                                                <td><mat-slide-toggle [checked]="consultancy" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.consultancy_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Academy</td>
                                                <td><mat-slide-toggle [checked]="academy" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.academy_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Project</td>
                                                <td><mat-slide-toggle [checked]="project" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.project_value }} </td>
                                            </tr>
                                            <tr>
                                                <td>Audit</td>
                                                <td><mat-slide-toggle [checked]="audit" class="example-margin"></mat-slide-toggle>  &nbsp; &nbsp; {{ userdata?.audit_value }} </td>
                                            </tr>                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>

</section>